<!--
 * @Author: Merlin
 * @Date: 2025-08-08 10:49:10
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-25 15:02:49
 * @Description: 入口页的大厅封面
-->
<template>
    <figure class="hall-cover" :class="{
            [disabled ? 'disabled' : 'normal']: true, 
            [`hall-${hallOrderNo}`]: true, 
        }">
        <!--
            ↑ 背景图 
            ↓ 内容 
        -->
        <div class="content">
            <h5 class="title">
                <img :src="oCurPics[`title`]" alt="" />
            </h5>
            <div class="info-box">
                <span>
                    <CurrentCoin size="12px" class="inline-flex coin-pic" />
                    <i class="font">{{ $t('goldenFlower.access') }}:</i>
                    <em class="font">
                        {{ info.minimumEntry }}
                    </em>
                </span>
                <span>
                    <CurrentCoin size="12px" class="inline-flex coin-pic" />
                    <i class="font">{{ $t('goldenFlower.ante') }}:</i>
                    <em class="font">
                        {{ info.minBet }}
                    </em>
                </span>
            </div>
            <div class="hall-cover-img" :style="{ backgroundImage: `url(${oCurPics.cover})` }">
                <img v-if="oCurPics.icon" class="cover-icon" :src="oCurPics.icon" alt="" @load="onIconLoad"
                    @error="onIconError" :class="{ 'icon-loaded': iconLoaded }">
            </div>
        </div>
    </figure>
</template>

<script lang="ts" setup>
import { fnGetCoverPics } from '../ts/goldenFlowerCommon'; 

const props = defineProps({
    hallOrderNo: {
        type: Number, 
        required: true, 
    },
    disabled: {
        type: Boolean,
    },
    info: {
        type: Object,
        default: () => ({}),
    },
});

const $i18n = useNuxtApp().$i18n;
const oPics = fnGetCoverPics();

const sLang = computed(()=>{
    return $i18n.locale.value;
});

const oCurPics = computed(()=>{
    const sNumber = `-0${props.hallOrderNo}`;
    const sJoin = `join-${sLang.value}`;
    const oResult: any = {
        join: oPics[sJoin],
    };
    Object.keys(oPics).forEach(key=>{
        const rightLang = (
            key.includes('title')
            ? key.includes(sLang.value)
            : true
        );
        if (key.includes(sNumber) && rightLang){ 
            const [shortKey] = key.split('-');
            oResult[shortKey] = oPics[key];
        }
    });
    return oResult; 
});

const iconLoaded = ref(false);

const onIconLoad = () => {
    iconLoaded.value = true;
};

const onIconError = () => {
    iconLoaded.value = true; // 即使加载失败也设置为true，避免一直显示加载状态
};

watch(() => oCurPics.value.icon, (newIcon) => {
    if (newIcon) {
        iconLoaded.value = false; // 当图标路径改变时，重置加载状态
    }
});

onMounted(()=>{
    // 检查图片是否已经在缓存中（可能在 @load 事件触发前就已经加载完成）
    nextTick(() => {
        if (oCurPics.value.icon) {
            const imgElement = document.querySelector(`.hall-${props.hallOrderNo} .cover-icon`) as HTMLImageElement;
            if (imgElement && imgElement.complete && imgElement.naturalHeight !== 0) {
                iconLoaded.value = true;
            }
        }
    });
});


</script>

<style scoped lang="scss" >
.hall-cover{
    min-width: 90px; 
    min-height: 100px; 
    max-width: 200px;
    max-width: min(45vw, 200px);
    position: relative; 
    font-size: 12px;
    transition: all 0.2s; 
    cursor: pointer; 
    &.normal:hover{
        transform: translateY(2px); 
    }
    .font {
        zoom: 0.83;
    }
    &.normal:active{
        transform: translateY(4px); 
        filter: brightness(1.15);
    }
    &.disabled{
        opacity: 1 !important; 
        filter: brightness(0.5);
    }
}

.hall-cover-img{
    filter: drop-shadow(2px 6px 10px rgb(0,0,0, 0.7));
    height: 100%;
    width: 100%;
    box-shadow: 0px 0px 10px 0px #FFFFFF66 inset;
    border-radius: 12px;
    overflow: hidden;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
    z-index: 1;
}
.cover-icon {
    position: absolute;
    left: 50%;
    right: 50%;
    bottom: 4px;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    &.icon-loaded {
        opacity: 1;
    }
}
.title,.info-box {
    position: relative;
    z-index: 2;
}
@media screen and (max-width: 380px){
    .hall-cover{
        font-size: 12px; 
        .font {
            zoom: 0.75;
        }
    }
}

.content{
    position: absolute; 
    top: 0;
    bottom: 0;
    left: 0;
    right: 0; 
    // z-index: 0; 
    user-select: none; 
    text-align: center; 
    display: flex;
    flex-direction: column;
    color: white; 
    & > *{
        display: flex;
        justify-content: center; 
        align-items: center; 
        min-height: 5px; 
        text-align: center; 
    }
    .title{
        margin-top: 10px; 
        width: 100%;
        color: white; 
        img{
            margin: 0 auto; 
            max-width: 90%; 
            max-height: 40px; 
        }
    }
    .info-box{
        margin: 0 auto;
        span{
            background: rgba(17, 25, 35, 0.8);
            color: rgba(255, 255, 255, 0.5);
            min-width: 40px;
            min-height: 17px;
            padding: 2px 4px;
            border-radius: 5px;
            border: solid 1px rgba(255,255,255, 0.3);
            display: flex;
            justify-content: center; 
            align-items: center; 
            text-align: center; 
            + span{
                margin-left: 4px; 
            }
            .coin-pic{
                margin: 0 2px 0 0;
            }
            em{
                color: rgba(255, 255, 255, 0.7); 
                font-weight: bold; 
                margin: 0 0 0 3px; 
            }
        }
    }
}

.hall-5{
    .title{
        padding-left: 12px; 
        margin-top: 20px;
    }
    .info-box{
        display: flex;
        flex-direction: column; 
        margin-top: 8px;
        span{
            +span{
                margin: 6px 0 0 0; 
            }
        }
    }
}

</style>

